import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { X } from "lucide-react";

const adImg = (p) => `${API}/advertising/image/${p}`;
const normUrl = (u) => (/^https?:\/\//i.test(u) ? u : `https://${u}`);

export const AdBanner = ({ className = "" }) => {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/advertising/active").then((r) => setAds(r.data || [])).catch(() => setAds([]));
  }, []);

  useEffect(() => {
    if (ads.length < 2) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % ads.length), 6000);
    return () => clearInterval(t);
  }, [ads]);

  if (hidden || ads.length === 0) return null;
  const ad = ads[idx % ads.length];

  return (
    <div className={`relative ${className}`} data-testid="ad-banner">
      <a
        href={normUrl(ad.link_url)}
        target="_blank"
        rel="noopener noreferrer sponsored"
        data-testid="ad-banner-link"
        className="group flex items-stretch gap-0 overflow-hidden border border-acid/30 bg-surface hard-shadow"
      >
        <img
          src={adImg(ad.image_path)}
          alt={ad.headline || ad.brand || "Sponsored"}
          className="h-20 sm:h-24 w-32 sm:w-44 object-cover border-r border-stroke shrink-0 transition-transform duration-500 group-hover:scale-105"
        />
        <div className="flex-1 min-w-0 py-3 px-4 pr-10 flex flex-col justify-center">
          <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-acid">Sponsored</div>
          {ad.headline && (
            <div className="font-display text-xl sm:text-2xl text-paper leading-tight truncate">{ad.headline}</div>
          )}
          {ad.brand && <div className="font-mono text-[11px] text-muted-gray truncate">{ad.brand}</div>}
        </div>
      </a>
      <button
        onClick={() => setHidden(true)}
        data-testid="ad-banner-dismiss"
        aria-label="Dismiss ad"
        className="absolute top-1.5 right-1.5 p-1 text-muted-gray hover:text-paper bg-ink/70 border border-stroke"
      >
        <X size={13} />
      </button>
    </div>
  );
};

export default AdBanner;
